import React, { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { routes } from 'config'
import { constants } from 'utils'
import {
  BaseLayout,
  Module,
  ModuleBody,
  CustomerSupportNumber,
} from 'components'

const MembershipExpired: FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (
      sessionStorage.getItem(constants.BROWSER_STORAGE_KEY.IS_INACTIVE_MEMBER)
    ) {
      sessionStorage.removeItem(
        constants.BROWSER_STORAGE_KEY.IS_INACTIVE_MEMBER,
      )
    } else {
      navigate(routes.login)
    }
  }, [navigate])

  return (
    <BaseLayout>
      <Module>
        <ModuleBody>
          <Typography variant="h2">
            Sorry! You could not be logged in because your Bright MLS
            subscription is inactive.
          </Typography>
          <Typography variant="body1">
            To reinstate your account, please contact the Customer Support
            Center at <CustomerSupportNumber />. Thank you.
          </Typography>
        </ModuleBody>
      </Module>
    </BaseLayout>
  )
}

export default MembershipExpired
